const repeatableIdSeparator = '__';

export {
    repeatableIdSeparator
};
